import {createHeader, createLink, createInput, createCloseButton, createInfoBlock, createDobInput, createBackButton, createConfirmationCheckbox } from '../utilities/elements.js';
import { toCurrency } from '../utilities/numberFormats.js';
import { helmetIcon } from '../utilities/icons.js';
import {addSpinner, removeSpinner} from '../utilities/spinner.js';
import Reservation from './reservation.js';

function ReservationForm( targetEl, autoLoadForm, isFamilyEvent, bookingQty, qtyCadets, qtyInduction, price, regularPrice, onSale, inductionPrice, partyInfo ){
  this.targetEl = targetEl;
  this.autoLoadForm = autoLoadForm;
  this.isFamilyEvent = isFamilyEvent;
  this.bookingQty = bookingQty;
  this.qtyCadets = qtyCadets;
  this.qtyInduction = qtyInduction;
  this.price = price;
  this.regularPrice = regularPrice;
  this.onSale = onSale;
  this.inductionPrice = inductionPrice;
  this.partyInfo = partyInfo;
}

ReservationForm.prototype.addFormElements = function (reservationForm, eventId, eventReservationId, eventName, start, duration, productId, wcProductId, trackId, currentUser, currentParticipants, maxParticipants) {

  let subtotal = this.calculateOrderTotal();
  
  //dates and times
  let dateDisplay = start.format('dddd, MMMM Do YYYY');
  let timeDisplay = start.format('H:mm');
  // timeDisplay += ' - ' + start.clone().add(duration, 'm').format('H:mm');
  //back button
  reservationForm.appendChild( createCloseButton(reservationForm, '<< back', 'back', 'button', 'text-button') );
  //header
  reservationForm.appendChild(createHeader('h2', eventName));
  //date and time
  let dateInfo = createInfoBlock( null, [{content: dateDisplay}, {content: timeDisplay}]);
  dateInfo.classList.add('date-info');
  reservationForm.appendChild( dateInfo );

  let elementType = "";

  //quantities
  if (this.autoLoadForm) {
    console.log("Is autoload form");
    // show input boxes for quantities
    elementType = "input";
    let quantitiesCont = document.createElement('div');
    quantitiesCont.classList.add('quantities');
    this.displayQuantities( reservationForm, quantitiesCont, trackId, this.bookingQty, this.qtyCadets, this.qtyInduction, this.partyInfo, elementType );
    reservationForm.appendChild( quantitiesCont );
  } else {
    // show fixed quantities
    elementType = "infoBlock";
    let quantitiesCont = document.createElement('div');
    quantitiesCont.classList.add('quantities');
    this.displayQuantities( reservationForm, quantitiesCont, trackId, this.bookingQty, this.qtyCadets, this.qtyInduction, this.partyInfo, elementType );
    reservationForm.appendChild( quantitiesCont );
  }

  //show inductions block
  this.showInductions();

  reservationForm.appendChild( this.drawOrderTotal() );

  //enter details
  reservationForm.appendChild( createHeader('h4', 'Please enter your details') );

  let nameInput = createInput(reservationForm, 'Full name', 'name', 'text', '', true, 'full name');
  let emailInput = createInput(reservationForm, 'Your E-mail', 'email', 'email', '', true, 'e-mail');
  let dobInputEl = createDobInput();
  reservationForm.appendChild( dobInputEl );
  let telephoneInput = createInput(reservationForm, 'Phone number', 'telephone', 'text', '', true, 'phone number');
  //confirmation checkbox
  let confirmationEl = createConfirmationCheckbox( 'consent', 'consent-input', 'We require your e-mail address to manage your reservation in our booking system. We may send you a courtesy email to check that you were able to book successfully. Please tick this box if you are happy to proceed.', true, 'consent-cont' );
  reservationForm.appendChild( confirmationEl );

  //add user details
  if( currentUser ){
    if( currentUser.name.length > 0 && currentUser.name !== ' ' ){
      nameInput.value = currentUser.name;
    }
    if( currentUser.email ){
      emailInput.value = currentUser.email;
    }
  }

  // hidden inputs
  createInput(reservationForm, 'WC Product ID', 'wc-product-id', 'hidden', wcProductId);
  this.subTotalInput = createInput(reservationForm, 'Subtotal', 'subtotal', 'hidden', subtotal);
  createInput(reservationForm, 'Event ID', 'event-id', 'hidden', eventId);
  createInput(reservationForm, 'Event Reservation ID', 'event-reservation-id', 'hidden', eventReservationId);
  createInput(reservationForm, 'Product ID', 'product-id', 'hidden', productId);
  createInput(reservationForm, 'Start', 'start', 'hidden', start.clone().format('YYYY-MM-DD HH:mm:ss'));
  this.bookingQtyInput = createInput(reservationForm, 'Qty', 'qty', 'hidden', parseInt(this.bookingQty, 10));
  this.qtyCadetsInput = createInput(reservationForm, 'Qty. Cadets', 'qty-cadets', 'hidden', parseInt(this.qtyCadets, 10));
  this.qtyInductionInput = createInput(reservationForm, 'Qty. Inductions', 'qty-induction', 'hidden', parseInt(this.qtyInduction, 10));

  //submit button
  createInput(reservationForm, '', 'submitButton', 'submit', 'Make Reservation');

  //close button
  let closeButton = createCloseButton(reservationForm, 'go back', 'cancel', 'button', 'close');
  reservationForm.appendChild(closeButton);
};

ReservationForm.prototype.showInductions = function () {
  
  // check exists
  if (document.getElementsByClassName('induction-select').length < 1) {

    let inductionTimeSelect = document.createElement('div');
    inductionTimeSelect.classList.add('induction-select');
    inductionTimeSelect.appendChild( createHeader('h4', 'Please choose an induction time') );
    let inductionTimesCont = document.createElement('div');
    inductionTimesCont.classList.add('induction-times');
    inductionTimeSelect.appendChild( inductionTimesCont );
  
    this.targetEl.appendChild(inductionTimeSelect);
    addSpinner( inductionTimesCont );

    if (this.qtyInduction < 1) {
      inductionTimeSelect.style.display = "none";
    }
  }

};

ReservationForm.prototype.displayQuantities = function (reservationForm, targetEl, trackId, elementType ) {

  let totalTitle = ( trackId === 1 || trackId === 3 ) ? 'Total Racers' : 'Total Participants';
  let qtyTotal = ( this.partyInfo.guests > 0 ) ? this.partyInfo.guests + this.partyInfo.extra_guests : this.bookingQty ;

  if (!this.autoLoadForm) {
    let qtyTotalEl = createInfoBlock( totalTitle, [{type: 'node', content: helmetIcon()}, {content: ' x' + qtyTotal}]);
    targetEl.appendChild( qtyTotalEl );
    if (qtyCadets > 0){
      let qtyAdultsEl = createInfoBlock( '(14+)', [{type: 'node', content: helmetIcon()}, {content: ' x' + (this.bookingQty - this.qtyCadets)}]);
      targetEl.appendChild( qtyAdultsEl );
      let qtyCadetsEl = createInfoBlock( '(8-13)', [{type: 'node', content: helmetIcon()}, {content: ' x' + this.qtyCadets}]);
      targetEl.appendChild( qtyCadetsEl );
    }
  } else {
    //enter details
    reservationForm.appendChild( createHeader('h4', 'How many people will be taking part?') );

    let qtyAdultsWrap = document.createElement("div");
    let qtyAdultsEl = createInput( qtyAdultsWrap, 'Drivers aged 14+', 'quantity-adults', 'number', 0, false, '', 0, 35, 2, 2, '[0-9]{2}' );
    qtyAdultsEl.addEventListener('change', this.onQuantityChange.bind(this) );
    targetEl.appendChild( qtyAdultsWrap );

    let qtyCadetsWrap = document.createElement("div");
    let qtyCadetsEl = createInput( qtyCadetsWrap, 'Drivers aged 8-13', 'quantity-cadets', 'number', 0, false, '', 0, 35, 2, 2, '[0-9]{2}' );
    qtyCadetsEl.addEventListener('change', this.onQuantityChange.bind(this) );
    targetEl.appendChild( qtyCadetsWrap );

    let qtyInductionsWrap = document.createElement("div");
    let qtyInductionsEl = createInput( qtyInductionsWrap, 'Number of inductions', 'quantity-inductions', 'number', 0, false, '', 0, 35, 2, 2, '[0-9]{2}' );
    targetEl.appendChild( qtyInductionsWrap );
    this.inductionsInput = qtyInductionsEl;
  }

};

ReservationForm.prototype.addInductionTime = function ( time, index, inductionEventResId, inductionEventId ) {

  let timeFormat = time.format('YYYY-MM-DDTHH:mm:ss');
  let timeLabel = time.format('H:mm dddd, Do MMMM YYYY'); 
  let inductionContainer = document.getElementsByClassName('induction-times')[0];
  //remove spinner
  if( inductionContainer.classList.contains('loading') ){
    removeSpinner( inductionContainer );
  }

  let inductionInput = document.createElement('input');
  inductionInput.type = 'radio';
  inductionInput.name = 'induction-time';
  inductionInput.id = 'induction-time-' + index;
  inductionInput.value = timeFormat;
  inductionInput.required = true;
  //add event res id and event id
  if( inductionEventResId ){
    inductionInput.setAttribute( 'data-event-reservation', inductionEventResId );
  }
  if( inductionEventId ){
    inductionInput.setAttribute( 'data-event-id', inductionEventId );
  }
  let inductionLabel = document.createElement('label');
  let inductionLabelText = document.createTextNode( timeLabel );
  inductionLabel.setAttribute( 'for', 'induction-time-' + index );
  inductionLabel.appendChild( inductionLabelText );

  inductionContainer.appendChild( inductionInput );
  inductionContainer.appendChild( inductionLabel );
};

ReservationForm.prototype.noInductionsAvailable = function () {
  let inductionContainer = document.getElementsByClassName('induction-times')[0];
  inductionContainer.classList.add('no-availability');
  removeSpinner( inductionContainer );

  let headerEl = createHeader('h3', 'No inductions available');
  let infoEl = document.createElement('p');
  infoEl.innerHTML = 'Sorry, there are no induction slots available on this date. Please call us on <a href="tel:01915214050">0191 521 4050</a> to see when we can accommodate you.';
  inductionContainer.appendChild(headerEl);
  inductionContainer.appendChild(infoEl);
  //remove inputs
  let childNodes = document.getElementById('reservation_form').children;
  [...childNodes].forEach( function( child ){
    if( child.tagName === 'INPUT' ){
      child.disabled = true;
    }
  })
  //remove dob input
  let dobInputs = document.getElementsByClassName('dob-input');
  [...dobInputs].forEach( function( input ){
    input.disabled = true;
  })

  //remove submit button
  let submitButton = document.getElementsByName('submitButton')[0];
  submitButton.parentNode.removeChild(submitButton);
};

ReservationForm.prototype.onQuantityChange = function (e) {
  
  let adultQtyInput = parseInt(document.getElementsByName('quantity-adults')[0].value, 10);
  let cadetQtyInput = parseInt(document.getElementsByName('quantity-cadets')[0].value, 10);
  let inductionQtyInput = parseInt(document.getElementsByName('quantity-inductions')[0].value, 10);

  this.qtyCadets = cadetQtyInput;
  this.qtyInduction = inductionQtyInput;
  this.bookingQty = cadetQtyInput + adultQtyInput;

  // update hidden quantitys and totals
  this.subTotalInput.value = this.calculateOrderTotal();
  this.bookingQtyInput.value = this.bookingQty;
  this.qtyCadetsInput.value = this.qtyCadets;
  this.qtyInductionInput.value = this.qtyInduction;

  // get existing subtotal element to change in dom
  let existingSubtotalEl = document.getElementsByClassName('subtotal-area')[0];
  existingSubtotalEl.parentNode.replaceChild(this.drawOrderTotal(), existingSubtotalEl);

}

ReservationForm.prototype.calculateOrderTotal = function () {

  //prices
  let subtotal = parseFloat(this.price, 10) * parseInt(this.bookingQty, 10);
  if( this.qtyInduction > 0 ){
    subtotal += ( parseFloat(this.inductionPrice, 10) * parseInt(this.qtyInduction, 10) );
  }
  if(this.partyInfo.extra_guests > 0){
    subtotal += ( this.partyInfo.extra_guest_price * this.partyInfo.extra_guests );
  }

  return subtotal;

};

ReservationForm.prototype.drawOrderTotal = function () {

    let subTotalEl = createInfoBlock( 'Sub-Total', [{content: this.orderTotalContent() , innerhtml: true}]);
    subTotalEl.classList.add('subtotal-area');
    this.subTotalEl = subTotalEl;
    return subTotalEl; 

};

ReservationForm.prototype.orderTotalContent = function () {
  
  let subtotal = this.calculateOrderTotal();
  //sub-total and per person
  let regularPriceText = '';
  if( this.onSale && this.regularPrice ){
    regularPriceText = '<strike>' + toCurrency( parseFloat(this.regularPrice, 10), '£' ) + '</strike>';
  }
  let inductionSubTotalDisplay = ( this.qtyInduction > 0 ) ? ', plus ' + this.qtyInduction + 'x ' + toCurrency( parseFloat(this.inductionPrice, 10), '£' ) + ' for inductions' : '' ;
  let subTotalDisplay = toCurrency( subtotal, '£' ) + ' (' + this.bookingQty + 'x ' + regularPriceText + toCurrency( parseFloat(this.price, 10), '£' ) + ' per person' + inductionSubTotalDisplay + ')';
  //if party, change subtotal display
  if( this.partyInfo.guests > 0 ){
    subTotalDisplay = toCurrency( subtotal, '£' ) + ' (includes ' + this.partyInfo.extra_guests + 'x extra guests at ' + toCurrency( this.partyInfo.extra_guest_price, '£' ) + ' per guest.)';
  }
  return subTotalDisplay;
};

export default ReservationForm;
